import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { List } from '@pella/sash-framework';
import { CTA } from '../../../';

const PerformanceMenu = ({ data, children }) => (
	<List
		bullets='none'
		className='mobilePerfMenu invisible absolute -right-80 top-0 z-[11] h-[calc(100svh-59px)] w-full overflow-hidden bg-white shadow-xl motion-safe:transition-all motion-safe:duration-500 sm:h-[calc(100svh-63px)]'
	>
		{children}

		{data.category?.map((resource, index) => (
			<li
				key={index}
				className={`bg-white px-4 ${index > 0 ? 'my-10' : ''}`}
			>
				{resource.heading && (
					resource.direct_link ? (
						<Link
							className='no-underline'
							to={resource.direct_link}
						>
							<p className='mb-2 text-base font-semibold text-gray-70'>{resource.heading}</p>
						</Link>
					) : (
						<p className='mb-2 text-base font-semibold text-gray-70'>{resource.heading}</p>
					)
				)}

				{resource.entries?.[0] && (
					<List
						bullets='none'
						className='space-y-2'
					>
						{resource.entries?.map((entry, index) => (
							<li key={index}>
								<CTA
									data={entry}
									className='inline-block text-xs text-gray-70 no-underline'
									renderAs='link'
								/>
							</li>
						))}
					</List>
				)}
			</li>
		))}
	</List>
);

PerformanceMenu.propTypes = {
	data: PropTypes.object.isRequired,
	children: PropTypes.node,
};

export default PerformanceMenu;
